import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useRsrc } from '@/common/rsrc/RsrcContext'
import { StringUtils } from '@/common/utils/StringUtils';

export const ConfirmDeleteDialog = ({ data, closeDialog }) => {
  const rsrc = useRsrc();

  const deleteEntity = () => {
    rsrc.delete(data.module, data.entity, data.id).then(closeDialog);
  }

  return (
    <Dialog open fullWidth onClose={closeDialog}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this {StringUtils.toCapitalizedWords(data.entity)} record?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button data-test-id="cancel-button" onClick={closeDialog}>Cancel</Button>
        <Button color="error" data-test-id="delete-button" onClick={deleteEntity}>Delete</Button>
      </DialogActions>
    </Dialog>
  )
}
